import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    labelDefault: string;
    labelRole: (roleName: string) => string | React.ReactNode;
    removeMember: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Aria label for the default role select */
            labelDefault: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "InviteAccessMemberRoleSelect.labelDefault?c=cggxorkvqhki", defaultMessage: "Change role" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Aria label for the role select */
            labelRole: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (roleName: string) => __intl__.intl().formatMessage({ id: "InviteAccessMemberRoleSelect.labelRole?c=11ijidv02peeg", defaultMessage: "Current role: {roleName}" }, { roleName: roleName }));
                },
                enumerable: true,
                configurable: true
            },
            /** Text for the remove member button */
            removeMember: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "InviteAccessMemberRoleSelect.removeMember?c=2p2nn96ea4b9x", defaultMessage: "Remove access" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
